<div class="lancaItemCabecalho">
	<h2 class="titulo">Pedido</h2>
	<mat-divider class="divider"></mat-divider>
	<form class="formulario">
		<div class="valores">
			<div>
				@if (itemDetalhado.itemPedido.flPromocao  && itemDetalhado.itemPedido.preco > 0) {
				<label class="promocao">
					PROMOÇÂO
				</label>
				}
				@if (itemComercializavel && itemDetalhado.itemPedido.quantidade > 0) {
				<app-quantidade-lista [detalhada]="true" [item]="itemDetalhado"
					[unMedVenda]="itemDetalhado.itemPedido.unMedVenda"
					[quantidadeItemString]="itemDetalhado.itemPedido.quantidade.toLocaleString('pt-BR',{useGrouping: false})">
				</app-quantidade-lista>
				}
			</div>
			@if (exibeEstoque) {
			<mat-form-field class="cor">
				<mat-label>Quantidade estoque ({{itemDetalhado.itemDetalhes.unMedEstoque}})</mat-label>
				<input matInput type="number" [(ngModel)]="itemDetalhado.itemDetalhes.qtDisponivel" name="qtdeEstoque"
					disabled>
			</mat-form-field>
			}
			@if (itemComercializavel && itemDetalhado.itemPedido.preco > 0) {
			<div class="precoPrecoSt margin-top-10 width-100">
				<mat-form-field class="cor width-50">
					<mat-label>Preço</mat-label>
					<input class="precoBold" matInput type="text"
						[ngModel]="itemDetalhado.itemPedido.valorLiquido | currency:'R$':'code'" name="preco" readonly>
				</mat-form-field>
				<mat-form-field class="cor width-50 padding-left-5">
					<mat-label>Preço + ST. + IPI</mat-label>
					<input class="precoBold" matInput type="text"
						[ngModel]="itemDetalhado.itemPedido.valorLiquidoIpiSt | currency:'R$':'code'" name="precoStIpi"
						readonly>
				</mat-form-field>
			</div>
			<mat-form-field class="cor width-100">
				<b>
					<mat-label>Total</mat-label>
				</b>
				<b><input matInput type="text" [ngModel]="itemDetalhado.itemPedido.total | currency:'R$':'code'"
						name="total" disabled></b>
			</mat-form-field>
			} @else {
			<div class="consulte-vendedor margin-top-10">
				<p>Consulte disponibilidade e valor com vendedor</p>
			</div>
			}
			<div class="width-100">
				@if ((!itemComercializavel || itemDetalhado.itemPedido.preco <=0) && podeConsultarEstoqueOutraFilial) {
				<mat-label class="texto-botao">
					Disponível em outra filial
				</mat-label>
				}
				@if (!itemNoCarrinho) {
				<button
					[disabled]="(!itemComercializavel || itemDetalhado.itemPedido.valorLiquido <=0) && !podeConsultarEstoqueOutraFilial"
					mat-raised-button color="primary" class="adicionarCarrinho" (click)="adicionarItemAoCarrinho()">
					{{(!itemComercializavel || itemDetalhado.itemPedido.preco <=0)
						? ( podeConsultarEstoqueOutraFilial ? "Consultar disponibilidade" : "Indisponível") : 'Adicionar no carrinho' }}</button>
				}
			</div>
		</div>
		<div class="width-100">
			<app-lista-preco class="tabela-preco" [itemDetalhado]="itemDetalhado" [dialogParent]="true"
				(tabelaPrecoEmitter)="getTabelaPrecoEmitter($event)">
			</app-lista-preco>
		</div>
	</form>
</div>
